<template>
  <div class="home">
    <div v-if="!this.$route.params.amount">
      <h3 style="text-align: center">Something went wrong....</h3>
      <h5 style="text-align: center">Please try after some time.</h5>
    </div>
    <div v-else-if="loading">
      <h3 style="text-align: center">Loading....</h3>
      <h5 style="text-align: center">Please Donot Refresh page.</h5>
    </div>
    <div v-else-if="payment_sucess">
      <h3 style="text-align: center">
        Thank you, your application has been received successfully.
      </h3>
      <h5 style="text-align: center">
        <a style="cursor: pointer" @click="preview">Click here</a> to view your
        submitted application.
      </h5>
      <!-- <h5 style="text-align: center">Your Application ID : SFA{{ ref }}</h5> -->
    </div>
    <div v-else>
      <h3 style="text-align: center">Payment Failed.</h3>
      <h5 style="text-align: center">Please Donot Refresh page.</h5>
      <h5 style="text-align: center">
        Please don't make repeated payments, if already paid. Please check your
        submitted application and payment status in the homepage view
        application link later.
      </h5>
      <br />
      <h5>Please contact us through email for more clarifications.</h5>
      <!-- <center>
        <md-button class="md-danger" @click="makePayment">Try again</md-button>
      </center> -->
    </div>
    <!-- <form>
      <input v-model="price" type="text" />
      <button @click="makePayment">GO</button>
    </form> -->
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { db, applicationsCollection, departmentsCollection } from "@/firebase";
export default {
  name: "home",
  components: {},
  data() {
    return {
      price: 0,
      loading: true,
      payment_sucess: false,
      ref: "",
    };
  },
  created: function () {
    if (this.$route.params.amount) {
      this.makePayment();
    }
  },
  methods: {
    preview() {
      console.log("en");
      let self = this;
      db.collection("applications")
        .doc(self.$route.params.docid)
        .get()
        .then((doc) => {
          self.$router.push({
            name: "userapplication",
            params: {
              preview: doc,
            },
          });
        });
    },
    sendEmail() {
      axios
        .post(
          "https://us-central1-aavinfedrecruitment-a425e.cloudfunctions.net/sendMail",
          // "http://localhost:5000/aavinfedrecruitment-a425e/us-central1/sendMail",
          {
            toEmail: this.$route.params.email,
            name: this.$route.params.name,
            applicationId: this.ref,
          }
        )
        .then((resp) => {
          console.log("response", resp);
          swal({
            title: "Conformation",
            text: "An email conformation is send to your email address.",
            type: "success",
            showConfirmButton: true,
            confirmButtonClass: "md-button md-info",
          });
        });
    },
    // Initializing the payment request
    makePayment: function () {
      let self = this;
      // 1. GENERATE ORDER_ID using razorpay/order api
      axios
        .post(
          "https://us-central1-aavinfedrecruitment-a425e.cloudfunctions.net/order",
          {
            //   amount: this.$route.params.amount,
            amount: (this.$route.params.amount * 100).toString(),
          }
        )
        .then((res) => {
          self.setorderid(res.data.id);
          var rzp1 = new Razorpay({ ...options, order_id: res.data.id });
          rzp1.open();
        })
        .catch((err) => {
          console.log("ERR", err);
        });

      //  create options object when creating order
      var options = {
        key: "rzp_live_zO9nx5EHMZ7mz5", //rzp_test_3ix8ePsU0CXI8M
        // amount: this.$route.params.amount, /// The amount is shown in currency subunits. Actual amount is ₹1.
        name: "Aavin",
        amount: (this.$route.params.amount * 100).toString(),
        currency: "INR", // Optional. Same as the Order currency
        description: "Job payment",
        image: "https://aavinfedrecruitment-a425e.web.app/img/aavin/company_logo.png",
        handler: (response) => {
          this.verifySignature(response);
        },
        prefill: {
          name: this.$route.params.name,
          email: this.$route.params.email,
        },
        notes: {
          address: "Hello World",
        },
        theme: {
          color: "#00ffff",
        },
      };
    },
    verifySignature: function (response) {
      let self = this;
      self.loading = true;
      axios
        .post(
          "https://us-central1-aavinfedrecruitment-a425e.cloudfunctions.net/paymentApi",
          response
        )
        .then((res) => {
          self.loading = false;
          self.payment_sucess =
            res.data == "PAYMENT SUCCESSFULL" ? true : false;
          console.log("PAYMENT RESPONSE", res.config);
          if (res.data == "PAYMENT SUCCESSFULL") {
            self.getapplicationid(res.config);
            self.sendEmail();
          } else {
            self.loading = false;
          }
        })
        .catch((err) => {
          self.loading = false;
          self.payment_sucess = false;
          console.log("error", err);
        });
    },
    setorderid(orderid) {
      db.collection("applications").doc(this.$route.params.docid).set(
        {
          order_id: orderid,
        },
        { merge: true }
      );
    },
    getapplicationid(paymentres) {
      let self = this;
      console.log("doc id ", self.$route.params.docid);
      db.collection("departments")
        .doc(self.$route.params.post)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            console.log("No such document!");
            self.loading = false;
          } else {
            self.ref = doc.data().prefix;
            self.loading = false;
            db.collection("applications")
              .doc(self.$route.params.docid)
              .set(
                {
                  razerpay: JSON.parse(paymentres.data),
                  applicationId: "",
                  verify: false,
                },
                { merge: true }
              );
            // self.updateapplicationid(doc.data().lastNumber);
          }
        });
    },
    updateapplicationid(LN) {
      db.collection("departments")
        .doc(this.$route.params.post)
        .set(
          {
            lastNumber: LN + 1,
          },
          { merge: true }
        );
    },
  },
};
</script>

<style scoped>
input {
  border: 1px solid rgb(0, 217, 255);
  padding: 8px 40px;
  text-align: center;
}
button {
  background: rgb(0, 241, 161);
  border: none;
  padding: 8px 30px;
  margin: 16px;
}
</style>